<app-header [isLoggedIn]="isLoggedIn"></app-header>
<div class="mainBox">
  <p class="header">Please click on the below button to accept the doctor Registration</p>
  <button class="btn btn-success" (click)="activateDoctor()">Accept</button>
  <button class="btn btn-secondary mr-2" (click)="openConfirmationDialog()">Reject</button>
</div>
<block-ui></block-ui>
